import './style.scss';

import React from 'react';
import classnames from 'classnames';

const Container = ({ block, round, className, children }) => (
  <div
    className={classnames({
      card: true,
      'card--block': !!block,
      'card--round': !!round,
      [className]: !!className
    })}
  >
    {children}
  </div>
);

const Image = ({ className }) => (
  <div className={classnames('card__image', className)} />
);

const Text = ({ children }) => <div className="card__text">{children}</div>;

export default Container;
export { Container, Image, Text };
